import React, { useState } from "react";
import { EyeSlashIcon, EyeIcon } from "@heroicons/react/24/outline";

const shellVariants = {
  default:
    "rounded bg-[#364153] border-[1.5px] border-[#4A5567] hover:border-gray-300",
  glass:
    "rounded-lg border border-white/10 bg-white/[0.06] shadow-inner transition-colors hover:border-white/15 focus-within:border-primaryBlue/60 focus-within:ring-2 focus-within:ring-primaryBlue/35",
};

const inputVariants = {
  default: "bg-[#364153] rounded-sm",
  glass:
    "bg-transparent placeholder:text-white/50 rounded-lg focus:placeholder:text-white/40",
};

export default function AuthInput({
  type,
  name,
  id,
  label,
  placeholder,
  errors,
  register = () => {},
  onChange = () => {}, // Default to a no-op function
  disabled = false,
  variant = "default",
}) {
  const [show, setShow] = useState(false);
  const onToggleShow = () => setShow(!show);
  const isPassword = type === "password";

  return (
    <div className="pb-2 pt-2">
{  label?.length?    <h5 className="mb-3 w-full  text-left text-md text-white">
        {label}
      </h5>:null}
      <div className={`flex gap-2 items-center ${shellVariants[variant] || shellVariants.default}`}>
        <input
          type={!isPassword ? type : isPassword && show ? "text" : type}
          id={id}
          placeholder={placeholder}
          className={`block w-full outline-0 p-4 py-3 text-md text-white ${inputVariants[variant] || inputVariants.default} ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
          {...register(name)}
          onChange={(e)=>{
            e.target.focus();
          }} // Handle input changes
          disabled={disabled}
          
          // autoFocus
        />
        {isPassword && (
          <div>
            {show ? (
              <EyeIcon
                onClick={onToggleShow}
                className={`h-6 w-6 mx-3 shrink-0 hover:cursor-pointer ${variant === "glass" ? "text-white/50 hover:text-white" : "text-gray-600 hover:text-gray-800"}`}
              />
            ) : (
              <EyeSlashIcon
                onClick={onToggleShow}
                className={`h-6 w-6 mx-3 shrink-0 hover:cursor-pointer ${variant === "glass" ? "text-white/50 hover:text-white" : "text-gray-600 hover:text-gray-800"}`}
              />
            )}
          </div>
        )}
      </div>
      {errors[name] && (
        <p className="text-red-800 mt-2 text-base md:text-base text-left ml-1">
          {errors[name]?.message}
        </p>
      )}
    </div>
  );
}
